<template>
  <div class="modal" :class="{ active: visible }" @click.self="handleClose">
    <div class="keyboard-container">
      <div style="display:flex;justify-content:space-between;padding:5px;">
        <b>输入会员号</b>
        <i class="el-icon-close" @click="handleClose" style="cursor:pointer; font-size: 1.2rem;"></i>
      </div>
      <div class="kb-display">{{ kbValue }}</div>
      <div class="kb-grid">
        <button class="kb-btn" @click="kbInput('1')">1</button>
        <button class="kb-btn" @click="kbInput('2')">2</button>
        <button class="kb-btn" @click="kbInput('3')">3</button>
        <button class="kb-btn" @click="kbInput('4')">4</button>
        <button class="kb-btn" @click="kbInput('5')">5</button>
        <button class="kb-btn" @click="kbInput('6')">6</button>
        <button class="kb-btn" @click="kbInput('7')">7</button>
        <button class="kb-btn" @click="kbInput('8')">8</button>
        <button class="kb-btn" @click="kbInput('9')">9</button>
        <button class="kb-btn" @click="kbInput('C')" style="color:red">C</button>
        <button class="kb-btn" @click="kbInput('0')">0</button>
        <button class="kb-btn confirm" @click="kbConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberKeyboardModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      kbValue: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.kbValue = ''
      }
    }
  },
  methods: {
    kbInput(v) {
      if (v === 'C') {
        this.kbValue = ''
      } else {
        this.kbValue += v
      }
    },
    kbConfirm() {
      this.$emit('confirm', this.kbValue)
      this.handleClose()
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  align-items: center;
  justify-content: center;
}

.modal.active {
  display: flex;
}

.keyboard-container {
  width: 320px;
  background: #e2e8f0;
  padding: 10px;
  border-radius: 12px;
}

.kb-display {
  background: white;
  padding: 15px;
  border-radius: 6px;
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 10px;
  min-height: 50px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kb-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.kb-btn {
  padding: 15px;
  font-size: 1.5rem;
  border: none;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  box-shadow: 0 2px 0 #cbd5e1;
  font-weight: bold;
}

.kb-btn:active {
  transform: translateY(2px);
  box-shadow: none;
}

.kb-btn.confirm {
  background: #2563eb;
  color: white;
  font-size: 1rem;
}
</style>

